import { render } from "./Islamabad.vue?vue&type=template&id=1aa7529b&scoped=true"
const script = {}

import "./Islamabad.vue?vue&type=style&index=0&id=1aa7529b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa7529b"]])

export default __exports__